import { render } from "./Canvas.vue?vue&type=template&id=c1d1c508&scoped=true"
import script from "./Canvas.vue?vue&type=script&lang=js"
export * from "./Canvas.vue?vue&type=script&lang=js"

import "./Canvas.vue?vue&type=style&index=0&id=c1d1c508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d1c508"]])

export default __exports__